import AppConstants from '../config/app.constants';

let HoldService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/hold`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let verify = (trackingId, date) => {
        return $http
            .post(AppConstants.api + `/hold/${trackingId}/verify`, {
                date
            })
            .then(({
                data
            }) => data)
    }

    let forceClose = (forceCloseShipments) => {
        return $http
            .post(AppConstants.api + `/hold/force-close`, { forceCloseShipments })
            .then(({ data }) => data)
    }

    let verifyHoldshipment = (branchId, trackingId, comments, supervisorUserId, vaultDate, bulkVerify) => {
        return $http
            .post(AppConstants.api + `/hold/verifyShipment`, {
                branchId,
                trackingId,
                comments,
                supervisorUserId,
                vaultDate,
                bulkVerify
            })
            .then((res) => {
                return res.data
            })
    }

    let verifyAtmResidual = (trackingId) => {
        return $http
            .get(AppConstants.api + `/hold/verifyAtmResidual`, {
                params: {
                    trackingId
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getResidualShipment = (trackingId, branchId) => {
        return $http
            .post(AppConstants.api + `/hold/get-residual-shipment`, {
                trackingId,
                branchId
            })
            .then((res) => {
                return res.data
            })
    };

    let softDeleteShipment = (trackingId, supervisorId, reason, shipmentId, branchId) => {
        return $http
            .post(AppConstants.api + `/hold/soft-delete-shipment`, {
                trackingId,
                supervisorId,
                reason,
                shipmentId,
                branchId
            })
            .then((res) => {
                return res.data
            })
    };

    let markToDelivered = (supervisorUserId, bagSealId) => {
        return $http
            .post(AppConstants.api + `/hold/mark-to-delivered`, {
                supervisorUserId,
                bagSealId
            })
            .then((res) => {
                return res.data
            })
    }

    let bulkVerify = (trackingId) => {
        return $http
            .post(AppConstants.api + `/hold/bulk-verify`, {
                trackingId
            })
            .then((res) => {
                return res.data
            })
    }

    let holdItemCount = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/hold/hold-item-count`, {
                params: {
                    search
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let holdItems = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/hold/get-item-holds`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let convertToCRV = (branchId, trackingLoad, trackingResidual, supvUserId, singleDenomTrackingIds) => {
        return $http
            .post(AppConstants.api + `/hold/convert-to-crv`, {
                branchId,
                trackingLoad,
                trackingResidual,
                supvUserId,
                singleDenomTrackingIds
            })
            .then((res) => {
                return res.data;
            })
    }

    let convertToCrvPackableOrder = (branchId, trackingLoad, packableOrderShipmentId, supvUserId) => {
        return $http
            .post(AppConstants.api + `/hold/convert-to-crv-packable-order`, {
                branchId,
                trackingLoad,
                packableOrderShipmentId,
                supvUserId
            })
            .then((res) => {
                return res.data;
            })
    }

    let getAllRoutes = (branchId, vaultDate) => {
        return $http
            .post(AppConstants.api + `/hold/get-all-routes`, {
                branchId,
                vaultDate
            })
            .then((res) => {
                return res.data;
            })
    }

    let updateRouteDetail = (routeId) => {
        return $http
            .post(AppConstants.api + `/hold/update-route-detail`, {
                routeId
            })
            .then((res) => {
                return res.data
            })
    }

    let verifyItemHoldData = (branch, status, verifiedDate) => {
        return $http
            .post(AppConstants.api + `/hold/verify-item-hold-data`, {
                branch,
                status,
                verifiedDate
            })
            .then((res) => {
                return res.data
            })
    }

    let shipmentDelivery = (trackingId, routeId, supervisorId, comments, branchId, loadedAmount, date, time, branchTimeZone, orderType, shipmentAmount, sendDeliveryReceipt=false) => {
        return $http
            .post(AppConstants.api + `/hold/shipment-delivery`, {
                trackingId,
                routeId,
                supervisorId,
                comments,
                branchId,
                loadedAmount,
                date, 
                time,
                branchTimeZone,
                orderType,
                shipmentAmount,
                sendDeliveryReceipt
            })
            .then((res) => {
                return res.data
            })
    };

    let holdShipmentList = (routeId, vaultDate, branch) => {
        return $http
            .post(AppConstants.api + `/hold/hold-shipment-list`, {
                routeId,
                vaultDate,
                branch
            })
            .then((res) => {
                return res.data
            })
    }

    let exportItemHoldData = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/hold/export-item-hold`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let shipmentHoldMarkCheckedIn = (trackingId, supervisorId, branchId, routeId) => {
        return $http
            .post(AppConstants.api + `/hold/mark-as-checked-in`, {
                trackingId,
                supervisorId,
                branchId,
                routeId
            })
            .then((res) => {
                return res.data
            })
    }

    let softDeleteBagoutsOnHold = (branchId, supvUserId, reason) => {
        return $http
            .post(AppConstants.api + `/hold/soft-delete-bagouts-on-hold`, {
                branchId, 
                supvUserId, 
                reason
            })
            .then((res) => {
                return res.data;
            })
    }

    let getBagoutsOnHold = (branchId) => {
        return $http
            .get(AppConstants.api + `/hold/get-bagouts-on-hold`, {
                params: { branchId }
            })
            .then((res) => {
                return res.data
            })
    };

    let pickupHoldRelease = (trackingId, origRouteId, destRouteId, destRouteDate, supervisorId, comments, branchId, locationId) => {
        return $http
            .post(AppConstants.api + `/hold/pickup-hold-release`, {
                trackingId, origRouteId, destRouteId,
                destRouteDate, supervisorId, comments,
                branchId, locationId
            })
            .then((res) => {
                return res.data
            })
    }

    let convertShipmentHoldToPickup = (trackingId, routeId, supervisorId, branchId, fromLocationId, toLocationId) => {
        return $http
            .post(AppConstants.api + `/hold/convert-shipment-hold-to-pickup`, {
                trackingId, routeId, supervisorId, branchId, fromLocationId, toLocationId
            })
            .then((res) => {
                return res.data
            })
    }

    let releaseForCount = (trackingId, routeId, supervisorId, comments) => {
        return $http
            .post(AppConstants.api + `/hold/release-for-count`, {
                trackingId, routeId, supervisorId, comments
            })
            .then(({ data }) => data)
    }

    return {
        all,
        verify,
        forceClose,
        verifyHoldshipment,
        verifyAtmResidual,
        getResidualShipment,
        softDeleteShipment,
        markToDelivered,
        bulkVerify,
        holdItemCount,
        holdItems,
        convertToCRV,
        convertToCrvPackableOrder,
        getAllRoutes,
        updateRouteDetail,
        verifyItemHoldData,
        shipmentDelivery,
        holdShipmentList,
        exportItemHoldData,
        shipmentHoldMarkCheckedIn,
        softDeleteBagoutsOnHold,
        getBagoutsOnHold,
        pickupHoldRelease,
        convertShipmentHoldToPickup,
        releaseForCount
    };
};

HoldService.$inject = ['$http', '$q']

export default HoldService;


// WEBPACK FOOTER //
// ./client/app/services/hold.service.js